/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import Topbar from '../../components/common/topbar/Topbar'
import { Integrator, StoreCatalogacion, TableAction, TableDetailCell, TableHeaderCell } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, MenuItem, Modal, Select} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close'
import classes from './StoresCatalogacion.module.css'
import { GridDTO } from '../../model/dto-module'
import axios from 'axios';
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import NewsanIcons from '../../components/common/Icons'
import PopupSuccessError from '../../components/common/popup-success-error/PopupSuccessError'
import { useNavigate } from 'react-router-dom'
import ConfirmDialog from '../../components/common/confirm-dialog/ConfirmDialog'
import { toast } from 'react-toastify'
import DragDropFileBucket from '../../components/common/drag-and-drop-bucket/DragAndDropBucket'

const StoresCatalogacion = () => {
  const navigate = useNavigate();
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>('/stores');  
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<GridDTO<StoreCatalogacion>>(endpoint, 'GET', undefined);
  const [loadingIntegrator, errorIntegrator, dataIntegrator] = useData<GridDTO<Integrator>>('/integrators', 'GET', undefined)
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const [dataResponse, setDataResponse] = useState<string | null>(null);
  const [selectedDescription, setSelectedDescription] = useState<string>('');
  const [selectedCode, setSelectedCode] = useState<string>('');
  const [selectedIntegrator, setSelectedIntegrator] = useState<Integrator|undefined>(undefined);
  const [selectedAllowBrand, setSelectedAllowBrand] = useState<boolean>(false);
  const [selectedAllowCategory, setSelectedAllowCategory] = useState<boolean>(false);
  const [selectedAllowAttribute, setSelectedAllowAttribute] = useState<boolean>(false);
  const [selectedApi, setSelectedApi] = useState<boolean>(false);
  const [selectedAllowSecond, setSelectedAllowSecond] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [newEditItem, setNewEditItem] = useState<StoreCatalogacion | undefined>();
  const [showForm, setShowForm] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedIntegratorId, setSelectedIntegratorId] = useState<number | null>(null);
  const [showOpenFileUploadModal, setShowOpenFileUploadModal] = useState(false);
  const handleCloseFileUploadModal = () => setShowOpenFileUploadModal(false);
  const notify = () => toast.loading('El archivo se está procesando...');

  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint('/stores')
  }, [baseEndpoint])

  useEffect(()=> {
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    setDataShow([])
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    let filterLoadeed = !loading && dataGrid != null &&  dataHeader.length === 0;
    filterLoadeed = filterLoadeed && !loadingIntegrator

    if(filterLoadeed) {
      setDataHeader([
        new TableHeaderCell({label: 'Código', key: 'code', sorteable: false}),
        new TableHeaderCell({label: 'Tienda', key: 'description', sorteable: false}),
        new TableHeaderCell({label: 'Integrador', key: 'integrator.description', sorteable: false}),
        /* new TableHeaderCell({label: 'Crear Marcas', key: 'allowCreateBrand', sorteable: false}),
        new TableHeaderCell({label: 'Crear Categoria', key: 'allowCreateCategory', sorteable: false}),
        new TableHeaderCell({label: 'Crear Atributos', key: 'allowCreateAttribute', sorteable: false}),
        new TableHeaderCell({label: 'Consulta api', key: 'api', sorteable: false}),
        new TableHeaderCell({label: 'Acepta 2da', key: 'allowSecondQuality', sorteable: false}), */
      ])  
    }
  })

  const fetchData = async ( body?: {description: string, code: string, integrator: {id: number}, allowCreateBrand: boolean, allowCreateCategory: boolean, allowCreateAttribute: boolean, allowSecondQuality: boolean, api: boolean}) => {
    try{
      setLoadingResponse(true)
      if (isEdit){
        await client.patch(`/stores/${newEditItem?.id}`, body)
        setDataResponse('Modificado con éxito!')
        setErrorResponse(null)
        setIsEdit(false)
        setNewEditItem(undefined)
      }else{
        await client.post('/stores', body)
        setDataResponse('Creado con éxito')
        setErrorResponse(null)
      }
      formatForm()
      setShowForm(false)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse([error.response?.data.message]);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
    } 
  }
  const formatForm = () => {
    setSelectedDescription('');
    setSelectedCode('');
    setSelectedAllowAttribute(false)
    setSelectedAllowBrand(false)
    setSelectedAllowCategory(false)
    setSelectedAllowSecond(false)
    setSelectedApi(false)
    setSelectedIntegrator(undefined)
  }

  const saveFormInfo = () => {
    // Validar campos del formulario
    if (!selectedDescription || !selectedIntegrator ){
      alert('Se deben completar todos los campos')
    } else {
      const temporalObject: {description: string, code: string, integrator: {id: number}, allowCreateBrand: boolean, allowCreateCategory: boolean, allowCreateAttribute: boolean, allowSecondQuality: boolean, api: boolean} = {
        description: selectedDescription,
        code: selectedCode,
        integrator: { id: selectedIntegrator.id },
        allowCreateAttribute: selectedAllowAttribute,
        allowCreateBrand: selectedAllowBrand,
        allowCreateCategory: selectedAllowCategory,
        allowSecondQuality: selectedAllowSecond,
        api: selectedApi
      }
      setShowPopup(true);
      fetchData(temporalObject)
    }
  }

  const deleteTemplateConfig = async (id: number) => {
    try{
      setLoadingResponse(true)
        await client.delete(`/stores/${id}`)
        setDataResponse('Eliminado con éxito!')
        setErrorResponse(null)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
    } 
  }

  useEffect(()=>{
    if(!loading && dataGrid) {
      setCountItems(dataGrid?.count)
      setDataShow(dataGrid?.results?.map((r, index) => {
        const actions : TableAction[] =[
          new TableAction({label: 'Editar', action: () => {
          formatForm()
          setNewEditItem(r)
          setIsEdit(true)
          setShowForm(true)
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
          new TableAction({label: 'Eliminar', action: async () => {
            await handleDeleteClick(r.id);
          },
          icon: NewsanIcons.DELETE
          }),
          new TableAction({label: 'Marcas', action: () => {
            navigate(`/tiendas/marcas/${r.id}`);
          }, icon: <span className={classes.editIcon}>{NewsanIcons.BOOKMARKS}</span>}),
          new TableAction({label: 'Categorías', action: () => {
            navigate(`/tiendas/categorias/${r.id}`);
          }, icon: <span className={classes.editIcon}>{NewsanIcons.CATEGORY}</span>}),
        ]
        if(!r.integrator.api){
          actions.push(
            new TableAction({
              label: 'Importar maestros',
              action: () => {
                setShowOpenFileUploadModal(true);
              },
              icon: <span className={classes.editIcon}>{NewsanIcons.XLSX_FILE}</span>
            })
          )
        }
        return new TableDetailCell(r, actions, new Map<string, React.ReactNode>([
          /* ['allowCreateBrand',
            <div key={index + 'allowCreateBrand'}>
              <Checkbox disabled checked={r.allowCreateBrand}></Checkbox>
            </div>
          ],
          ['allowCreateCategory',
            <div key={index + 'allowCreateCategory'}>
              <Checkbox disabled checked={r.allowCreateCategory}></Checkbox>
            </div>
          ],
          ['allowCreateAttribute',
            <div key={index + 'allowCreateAttribute'}>
              <Checkbox disabled checked={r.allowCreateAttribute}></Checkbox>
            </div>
          ],
          ['allowSecondQuality',
            <div key={index + 'allowSecondQuality'}>
              <Checkbox disabled checked={r.allowSecondQuality}></Checkbox>
            </div>
          ],
          ['api',
            <div key={index + 'api'}>
              <Checkbox disabled checked={r.api}></Checkbox>
            </div>
          ], */
        ]), classes['storesDataTable'])
      }))
    }
  }, [setDataShow, dataGrid, loading]);

  useEffect(()=>{

    if(newEditItem && isEdit){
      setSelectedDescription(newEditItem.description);
      setSelectedCode(newEditItem.code)
      setSelectedAllowAttribute(newEditItem.allowCreateAttribute)
      setSelectedAllowBrand(newEditItem.allowCreateBrand)
      setSelectedAllowCategory(newEditItem.allowCreateCategory)
      setSelectedApi(newEditItem.api)
      setSelectedIntegrator(newEditItem.integrator)
      setSelectedAllowSecond(newEditItem.allowSecondQuality)
    }
  }, [newEditItem, isEdit]);

  const handleDeleteClick = (relationId: number) => {
    setSelectedIntegratorId(relationId);
    setOpenConfirmDialog(true);
  };

  const confirmDelete = async () => {
    if (selectedIntegratorId !== null) {
      setShowPopup(true);
      setOpenConfirmDialog(false);
      await deleteTemplateConfig(selectedIntegratorId);
      setSelectedIntegratorId(null);
    }
  };

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
  }

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading || loadingResponse ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={'Tiendas'} hasReloadIcon reloadPage={reloadTable} />
      <div
        className={
          showForm ? classes['table-templates-container-form-visible'] : classes['table-templates-container']
        }
        >
          <DataTable
            headers={dataHeader}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>
      {showForm ? (
        <div className={classes['abm-container']}>
          <div className={isEdit ? classes['edit-form-container'] : classes['add-form-container']}>
            <span className={classes['title-form']}>
              {NewsanIcons.ADD_OUTLINED}{' '}
              <span className={classes['title-form-text']}>{isEdit ? 'Editar' : 'Agregar'} </span></span>
            <CloseIcon
              className={classes['form-close-button']}
              onClick={() => {
                formatForm()
                setShowForm(false)
                setIsEdit(false)
                setNewEditItem(undefined)
              }}
            ></CloseIcon>
            <span className={classes['setting-attr-title']}>Nombre de la tienda*</span>
            <input
              type='text'
              className={classes['setting-attr-input']}
              placeholder='Nombre de la tienda'
              defaultValue={selectedDescription}
              onChange={(e) => {
                setSelectedDescription(e.target.value);
              }}
              onInput={(e) => {
                const value = (e.target as HTMLInputElement).value;
                if(value == '') setSelectedDescription(value);
              }}
            />

            <span className={classes['setting-attr-title']}>Código de la tienda*</span>
            <input
              type='text'
              className={classes['setting-attr-input']}
              placeholder='Código de la tienda'
              defaultValue={selectedCode}
              onChange={(e) => {
                setSelectedCode(e.target.value);
              }}
              onInput={(e) => {
                const value = (e.target as HTMLInputElement).value;
                if(value == '') setSelectedCode(value);
              }}
            />

            <span className={classes['setting-attr-title']}>Integrador*</span>
            <FormControl className={classes['select-filter']} size='small'>
              <Select
                value={selectedIntegrator ? selectedIntegrator?.id.toString() : (newEditItem?.integrator?.id.toString() ?? null)}
                onChange={(e) => setSelectedIntegrator(dataIntegrator?.results?.find(integrator => integrator.id.toString() === e.target.value))}
              >
                <MenuItem value={''}>
                  <em className={classes['no-selection']}>Seleccionar</em>
                </MenuItem>
                {dataIntegrator?.results?.map((e)=>(
                  <MenuItem className={classes['select-option']} key={e.id} value={e.id.toString()}>
                  {e.description}
                </MenuItem>
              ))}
                
                
              </Select>
            </FormControl>
            <FormGroup aria-label="position" 
              sx={{
                alignItems: 'flex-start',
                '& .MuiFormControlLabel-root': {
                  width: '105%',
                  marginLeft: '-7%',
                  display: 'flex',
                  alignItems: 'center',
                }
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedAllowBrand}
                    onChange={(event) => setSelectedAllowBrand(event.target.checked)}
                  />
                }
                label="Crear Marcas"
                labelPlacement="start"
                className={classes.checkFieldForm}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedAllowCategory}
                    onChange={(event) => setSelectedAllowCategory(event.target.checked)}
                  />
                }
                label="Crear Categorías"
                labelPlacement="start"
                className={classes.checkFieldForm}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedAllowAttribute}
                    onChange={(event) => setSelectedAllowAttribute(event.target.checked)}
                  />
                }
                label="Crear Atributos"
                labelPlacement="start"
                className={classes.checkFieldForm}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedApi}
                    onChange={(event) => setSelectedApi(event.target.checked)}
                  />
                }
                label="Consulta API"
                labelPlacement="start"
                className={classes.checkFieldForm}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedAllowSecond}
                    onChange={(event) => setSelectedAllowSecond(event.target.checked)}
                  />
                }
                label="Acepta 2da"
                labelPlacement="start"
                className={classes.checkFieldForm}
              />
            </FormGroup>
            <div className={classes['buttons-container']}>
              <Button
                variant='contained'
                className={classes['btn-newsan-cancel']}
                onClick={() => {
                  setShowForm(false)
                  setIsEdit(false)
                  setNewEditItem(undefined)
                  setDataResponse(null)
                  setErrorResponse(null)
                  formatForm()
                }}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={async() => {await saveFormInfo();}}
                className={
                  isEdit ? classes['button-newsan-red'] : classes['button-newsan-grey']
                }
              >
                {isEdit ? 'Guardar' : 'Cargar'}
              </Button>
            </div>
          </div>
        </div>
      ) : (
          <span className={classes['btn-show-form']} onClick={() => setShowForm(!showForm)}>
            {NewsanIcons.ADD_OUTLINED}
          </span>
      )}
      </div>
        <ConfirmDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={confirmDelete}
          title="Confirmar eliminación"
          message="¿Está seguro de que desea eliminar esta configuración?"
        />
        <Modal
          open={showOpenFileUploadModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          onClose={(event, reason) => {
              handleCloseFileUploadModal();
          }}
        >
          <Box className={`${classes['side-upload']} ${classes.dragDropSide}`}>
            <DragDropFileBucket fileNamePrefix={'PRODUCTECA'} onChange={()=>{ 
              handleCloseFileUploadModal()
              return notify();
            }}></DragDropFileBucket>
            <div 
              className={classes['close-button-file-upload']}
            >
              <Button
                variant='contained'
                className={
                  classes['button-newsan-grey']
                }
                onClick={() => {
                  handleCloseFileUploadModal();
                }}
              >
                Cerrar
              </Button>
            </div>
          </Box>
        </Modal>
        {showPopup ? (<PopupSuccessError
          open={showPopup}
          onClose={() =>{ 
            setShowPopup(false);
            setDataResponse(null)
            setBaseEndpoint(errorResponse == null ? '' : baseEndpoint)
            setErrorResponse(null)
          }}
          loading={loadingResponse}
          success={dataResponse !== null}
          successMessage={dataResponse}
          errorMessage={errorResponse}
        />)
      :
      <></>}
    </div>
  )
}

export default StoresCatalogacion;
